module.exports = __webpack_public_path__ + "img/gou.f0b44253.png";